import moment from "moment";
import get from "lodash/get";

// Helper function to check date range

export const checkDateRange = (type, targetDate) => {
    const format = "YYYY-MM-DD"
    let startDate = moment().format(format)
    let endDate = moment().format(format)
    if (type === "Today") {
        startDate = moment().format(format)
    } else if (type === "Yesterday") {
        startDate = moment().subtract(1, 'd').format(format)
        endDate = moment().subtract(1, 'd').format(format)
    } else if (type === "Last 7 days") {
        startDate = moment().subtract(7, 'd').format(format)
    } else if (type === "Last 30 days") {
        startDate = moment().subtract(1, 'M').format(format)
    } else if (type === "Last six months") {
        startDate = moment().subtract(6, 'M').format(format)
    }

    return ((targetDate <= endDate) && (targetDate >= startDate))
}

export const historyFilter = (temp_state) => {
    const categoryFilter = temp_state.dropDowns.catergory.selectedItem;
    const recentFilter = temp_state.dropDowns.recent.selectedItem;
    let allHistDs = temp_state["allDescriptions"];
    temp_state["filteredDescriptions"] = {};

    let allDates = Object.keys(allHistDs)
    let filterObj = {}

    // Recent FIlter
    if (recentFilter === "Recent activities (All)") {
        allDates.forEach((dt) => {
            filterObj[dt] = allHistDs[dt]
        })
    } else {
        allDates.forEach((dt) => {
            let histArr = allHistDs[dt]
            if (checkDateRange(recentFilter, dt)) {
                filterObj[dt] = [...histArr]
            }
        });
    }

    // Category filter
    if (categoryFilter !== "all") {
        Object.keys(filterObj).forEach((dt) => {
            let histArr = filterObj[dt]
            let categoryFilterArr = [...histArr.filter((histDescObj) => histDescObj.category === categoryFilter)]
            if (categoryFilterArr.length > 0) {
                filterObj[dt] = categoryFilterArr
            } else {
                delete filterObj[dt]
            }
        })
    }

    temp_state["filteredDescriptions"] = filterObj
    temp_state["histSortedDates"] = Object.keys(filterObj).sort((a, b) => a < b ? 1 : -1)
}

// Helper fuction to check action response

export const histCheckActRes = (res, action) => {
    // Indexing is reversed in history
    // let descObj = res?.data[res?.data.length - action.payload.subDescInd - 1];
    if (res?.status !== "success") {
        return false;
    }
    // if (res?.data.length === 0) {
    //     return false;
    // }
    // if (descObj["gen_id"] !== action.payload.gen_id) {
    //     return false;
    // }
    // Object.keys(action.payload.actionInfo).forEach((actKey) => {
    //     if (descObj[actKey] !== action.payload.actionInfo[actKey]) {
    //         return false;
    //     }
    // });

    return true;
};

const startTenWords = (str) => {
    if (str.split(" ").length < 10) return str;

    return str.split(" ").splice(0, 10).join(" ");
};

// Helper function to segregate historic data
export const histSegregate = (responseArr, videoResArr, flyerResArr) => {
    let histObj = {}
    let allSocialMediaPromptTypes = ["Facebook", "Instagram", "Twitter", "Linkedin"]

    responseArr.forEach((obj, i) => {
        let date = moment(obj?.createdAt).format("YYYY-MM-DD")
        let descContainerObj = {
            title: obj?.order_id + " " + obj?.prompt_type,
            numberOfDesc: obj?.descriptions_generated?.length || 0,
            isOpen: false,
            isSelected: false,
            selectedIndex: -1,
            order_id: obj?.order_id,
            descriptions: [],
            form_schema: obj?.form_schema,
            category: obj?.prompt_type
        }

        if (obj?.prompt_type === "property_description") {
            descContainerObj.title = `Description (${get(
                obj,
                "form_schema[Property Address]",
                `Property description ${date}`
            )})`;
        } else if (obj?.prompt_type === "email") {
            descContainerObj.title = `Email (${obj.form_schema.purpose})`;
        } else if (obj?.prompt_type === "rewrite_paragraph") {
            descContainerObj.title = `Rewrite Content (${startTenWords(
                obj.form_schema.mainPoints
            )})`;
        } else if (allSocialMediaPromptTypes.includes(obj?.prompt_type)) {
            descContainerObj.title = `${obj?.prompt_type} (${obj.form_schema.topic})`;
        } else if (obj?.prompt_type === "realtor_bio") {
            descContainerObj.title = `Agent's Bio (${startTenWords(
                obj.form_schema.expertiseAndSpecialites
            )})`;
        } else {
            descContainerObj.title = `${obj?.prompt_type} (${date})`;
        }

        obj?.descriptions_generated.forEach((des, i) => {
            descContainerObj.descriptions.push({
                status: "Just now",
                description_generated: des?.description_generated || "",
                prompt: des?.prompt || "",
                gpt: des?.gpt || "",
                editedDesc: des?.description_generated || "",
                isEditing: false,
                isEdited: des?.is_edited || false,
                like_status: des?.like_status,
                generated_at: des?.createdAt || "",
                gen_id: des.gen_id,
                rewrite_count: des?.rewrite_count || 0,
            });
        });

        if (!histObj.hasOwnProperty(date)) {
            histObj[`${date}`] = [];
        }

        descContainerObj.descriptions.reverse();
        histObj[`${date}`].push(descContainerObj);
    });

    videoResArr.forEach((vidObj, i) => {
        let date = convToDate(vidObj?.createdAt);

        let vidContainerObj = {
            title: `Video (${(
                vidObj.rendersDoc.event.charAt(0).toUpperCase() +
                vidObj.rendersDoc.event.slice(1).toLowerCase()
            )
                .split("_")
                .join(" ")})`,
            category: "video",
            prompt_type: 'video',
            order_id: vidObj.rendersDoc.orderID,
            numberOfDesc: 1,
            dbData: { ...vidObj },
        };

        if (!histObj.hasOwnProperty(date)) {
            histObj[`${date}`] = [];
        }

        histObj[`${date}`].push(vidContainerObj);
    });


    let flyerHistoryObj = {};

    flyerResArr.forEach((flyerObj) => {
        let date = convToDate(flyerObj?.createdAt);

        let flyContainerObj = {
            title: `Flyer (${(
                flyerObj.eventType.charAt(0).toUpperCase() +
                flyerObj.eventType.slice(1).toLowerCase()
            )
                .split("_")
                .join(" ")})`,
            category: "flyer",
            prompt_type: 'flyer',
            numberOfDesc: 1,
            order_id: flyerObj.oid,
            dbData: { ...flyerObj },
        };

        if (!flyerHistoryObj.hasOwnProperty(date)) {
            flyerHistoryObj[`${date}`] = [];
        }

        flyerHistoryObj[`${date}`].push(flyContainerObj);
    });

    Object.keys(flyerHistoryObj).forEach(date => {
        let sortedDateOfFlyHist = [...flyerHistoryObj[date].reverse()];

        if (!histObj.hasOwnProperty(date)) {
            histObj[`${date}`] = [];
        }

        histObj[`${date}`].push(...sortedDateOfFlyHist);
    })

    return histObj;
};

export const convToDate = (inpDt) => {
    return moment(inpDt).format("YYYY-MM-DD")
}

// const testSample={
//     title:"Today",
//     descriptions:[
//         {
//             title:"191-27 Pineville Lane,  New York  NY 11413, United States of America 1",
//             numberOfDesc:2,
//             isOpen:false,
//             isSelected:false,
//             descs:[
//                 {
//                     generatedDesc:
//                         "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
//                     editedDesc: "",
//                     isEditing: false,
//                     isEdited: false,
//                     liked: null,
//                     generated_at: Date.now(),
//                 },
//                 {
//                     generatedDesc:
//                         "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
//                     editedDesc: "",
//                     isEditing: false,
//                     isEdited: false,
//                     liked: null,
//                     generated_at: Date.now(),
//                 },
//             ]

//         },
//         {
//             title:"191-27 Pineville Lane,  New York  NY 11413, United States of America 2",
//             numberOfDesc:2,
//             isOpen:false,
//             isSelected:false,
//             descs:[
//                 {
//                     generatedDesc:
//                         "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
//                     editedDesc: "",
//                     isEditing: false,
//                     isEdited: false,
//                     liked: null,
//                     generated_at: Date.now(),
//                 },
//                 {
//                     generatedDesc:
//                         "This beautiful 3 bedroom house is the perfect combination of modern elegance and historic charm. From the grand foyer and marble fireplace in the living room, to the hardwood cabinetry and marble countertops in the kitchen, this house is the ideal home for anyone looking for a luxurious and timeless living experience. The master bedroom features a spacious walk-in closet, proper sunlight, and an ensuite-bathroom with a soaking tub, walk-in shower and double vanity. The two other bedrooms are well-lit, and have been recently updated with modern bathrooms. The house also has a home gym and a sauna, ideal for those who enjoy a healthy lifestyle. There is also a balcony and a pergola covered patio, perfect for enjoying the quiet surrounding of the historic neighborhood. For the convenience of the future homeowners, the house is located near many grocery stores and schools. This is a great opportunity for anyone looking for a house with a combination of modern amenities and classic charm. Don't miss out on this amazing opportunity and come take a look today.",
//                     editedDesc: "",
//                     isEditing: false,
//                     isEdited: false,
//                     liked: null,
//                     generated_at: Date.now(),
//                 },
//             ]

//         },
//     ],
// }
